import { Dictionary, ReportFilterEnum, ReportSubSystemTypeWithGroup, ReportSystemType } from "../../types";

/**
 * Filter subsystems based on the selected units and report filters
 */
export const filterSubsystems = (subsystems: ReportSubSystemTypeWithGroup[], units: Dictionary<boolean>, items: ReportFilterEnum) => {
  const isUnitFilterEmpty = Object.keys(units).length === 0;

  return subsystems.filter(subsystem => {
    // skip subsystems that are not in the selected units
    if (!isUnitFilterEmpty && !units[subsystem.group?.id || '']) return false;

    switch (items) {
      case ReportFilterEnum.IssuesOnly:
        return subsystem.reportDeficiencies.length > 0 || subsystem.reportLimitations.length > 0;
      case ReportFilterEnum.MediaOnly:
        return subsystem.reportAttachments.length > 0
          || subsystem.reportInformations.some(info => info.reportAttachments.length > 0)
          || subsystem.reportLimitations.some(limitation => limitation.reportAttachments.length > 0)
          || subsystem.reportDeficiencies.some(deficiency => deficiency.reportAttachments.length > 0);
      case ReportFilterEnum.AppliancesOnly:
        return subsystem.reportInformations.some(info => {
            return info.reportApplianceInformation || info.questionType.indexOf('appliance') > -1;
          }
        );
      case ReportFilterEnum.FullReport:
      default:
        return true;
    }
  });
};

export const includesSowInspection = (reportSystems: ReportSystemType[]) => Boolean(
  reportSystems.some(({ reportSubsystems }) =>
    reportSubsystems.some(({ reportInformations }) =>
      reportInformations.some(({ dataName }) =>
        dataName?.includes('sow_completed'),
      ),
    ),
  ),
);

export const includesDrawInspection = (reportSystems: ReportSystemType[]) => Boolean(
  reportSystems.some(({ reportSubsystems }) =>
    reportSubsystems.some(({ reportInformations }) =>
      reportInformations.some(({ dataName }) =>
        dataName?.includes('division_progress'),
      ),
    ),
  ),
);
